import { vatItem } from '@/data';
import { useGeneralStore } from '@/stores/general';
import type { CartItem, EventItem } from '@/types';

import { formatDate } from './formatDate';
import { photoToUrl } from './photoToUrl';

export function eventToCartItem(event: EventItem): CartItem {
  const generalStore = useGeneralStore();
  const venues = generalStore.venues();
  const venueObj = venues.find(v => v.id === event.venue);
  const venueName = venueObj ? venueObj.name : '';

  let date = formatDate(event.eventtime || 0, { showTime: true });
  if (event.eventtime_override) {
    date = event.eventtime_override;
  }

  return {
    id: event.id,
    name: event.info1,
    currency: event.currency || 'DKK',
    vat: vatItem, // TODO make dynamic
    giftcard_allowed: true, // TODO make dynamic
    localizations: event.localizations || {},
    date,
    itemTimestamp: event.eventtime || 0,
    itemTimestampOverride: event.eventtime_override || null,
    venueName,
    image: photoToUrl(event.photo),
    tickets: [],
    addons: [],
  };
}
